import { api } from '@/lib/api'
import type {
  CreateAssignmentRequest,
  CreateNumberingSchemeRequest,
  NumberingScheme,
  NumberingSchemeAssignment,
  UpdateNumberingSchemeRequest,
} from './types'

// ---- Schemes ----

export async function listSchemes(): Promise<NumberingScheme[]> {
  const r = await api.get<NumberingScheme[]>('/api/admin/numbering-schemes')
  return r.data
}

export async function getScheme(code: string): Promise<NumberingScheme> {
  const r = await api.get<NumberingScheme>(`/api/admin/numbering-schemes/${code}`)
  return r.data
}

export async function createScheme(payload: CreateNumberingSchemeRequest): Promise<NumberingScheme> {
  const r = await api.post<NumberingScheme>('/api/admin/numbering-schemes', payload)
  return r.data
}

export async function updateScheme(code: string, payload: UpdateNumberingSchemeRequest): Promise<NumberingScheme> {
  const r = await api.patch<NumberingScheme>(`/api/admin/numbering-schemes/${code}`, payload)
  return r.data
}

export async function deactivateScheme(code: string): Promise<void> {
  await api.delete(`/api/admin/numbering-schemes/${code}`)
}

export async function resetSchemeCounter(code: string): Promise<void> {
  await api.post(`/api/admin/numbering-schemes/${code}/reset`)
}

// ---- Assignments ----

export async function listAssignments(): Promise<NumberingSchemeAssignment[]> {
  const r = await api.get<NumberingSchemeAssignment[]>('/api/admin/numbering-scheme-assignments')
  return r.data
}

export async function createAssignment(payload: CreateAssignmentRequest): Promise<NumberingSchemeAssignment> {
  const r = await api.post<NumberingSchemeAssignment>('/api/admin/numbering-scheme-assignments', payload)
  return r.data
}

export async function deleteAssignment(id: number): Promise<void> {
  await api.delete(`/api/admin/numbering-scheme-assignments/${id}`)
}
